import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"

export interface IGetNotificationReleaseCompletedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
}

export default class NotificationReleaseCompleted extends Notification {
    reservationId: Guid
    reservationNumber: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string

    constructor(dto: IGetNotificationReleaseCompletedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
    }
}
